import request from '@/utils/request'

export function getPurchaseOrders(branchId, size, page, find) {
  return request({
    url: `/tkitchen/purchaseorders/${branchId}`,
    method: 'get',
    params: {
      size: size,
      page: page,
      find: find
    }
  })
}

export function latestPurchaseOrders(branchId, dates, dateType) {
  return request({
    url: `/tkitchen/purchaseorders/latest/${branchId}`,
    method: 'get',
    params: {
      startDate: dates,
      dateType: dateType
    }
  })
}

export function getPurchaseOrderById(branchId, id) {
  return request({
    url: `/tkitchen/purchaseorders/id/${branchId}/${id}`,
    method: 'get'
  })
}

export function findPurchaseOrders(branchId, find) {
  return request({
    url: `/tkitchen/purchaseorders/list/${branchId}`,
    method: 'get',
    params: {
      find: find
    }
  })
}

export function createPurchaseOrders(branchId, data) {
  return request({
    url: `/tkitchen/purchaseorders/create/${branchId}`,
    method: 'post',
    data
  })
}

export function duplicatePurchaseOrders(branchId, id) {
  return request({
    url: `/tkitchen/purchaseorders/duplicate/${branchId}/${id}`,
    method: 'post'
  })
}

export function updatePurchaseOrders(branchId, id, data) {
  return request({
    url: `/tkitchen/purchaseorders/id/${branchId}/${id}`,
    method: 'put',
    data
  })
}

export function removePurchaseOrders(branchId, id) {
  return request({
    url: `/tkitchen/purchaseorders/id/${branchId}/${id}`,
    method: 'delete'
  })
}

export function getPurchaseOrderNotifications(branchId) {
  return request({
    url: `/tkitchen/purchaseorders/notifications/${branchId}`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/tkitchenPurchaseOrders.js